/**
 * EditorCheckbox — styled checkbox with label
 */

interface EditorCheckboxProps {
  label: string;
  checked: boolean | null | undefined;
  onChange: (checked: boolean) => void;
}

export function EditorCheckbox({ label, checked, onChange }: EditorCheckboxProps) {
  return (
    <label className="field-checkbox">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ display: 'none' }}
      />
      <span className="field-checkbox-toggle" />
      <span className="field-checkbox-label">{label}</span>
    </label>
  );
}
